import { GroupElementScroll, TextCaption } from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';

import { Benefit } from './benefits';

type BenefitCategoriesProps = {
  categories: Benefit['categories'];
};

export const BenefitCategories = ({ categories }: BenefitCategoriesProps) => {
  if (!categories) {
    return null;
  }

  return (
    <GroupElementScroll>
      {categories.map((category) => (
        <LinkWrapper
          key={category.label}
          href={category.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <TextCaption>{category.label}</TextCaption>
        </LinkWrapper>
      ))}
    </GroupElementScroll>
  );
};
